import { createReducer, on } from '@ngrx/store';
import * as ExpenseActions from './expenses.actions';
import { Expense } from './expenses.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ExpensesState {
    expenses: Expense[];
    expense: Expense | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialExpensesState: ExpensesState = {
    expenses: [],
    expense: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Expenses Reducer
export const expensesReducer = createReducer(
    initialExpensesState,

    // On Load Expenses
    on(ExpenseActions.loadExpenses, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseActions.loadExpensesSuccess, (state, { expenses }) => ({
        ...state,
        isLoading: false,
        expenses: expenses,
    })),
    on(ExpenseActions.loadExpensesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Expense
    on(ExpenseActions.loadExpense, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseActions.loadExpenseSuccess, (state, { expense }) => ({
        ...state,
        isLoading: false,
        expense: expense,
    })),
    on(ExpenseActions.loadExpenseFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(ExpenseActions.createExpense, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseActions.createExpenseSuccess, (state, { expense }) => ({
        ...state,
        isLoading: false,
        expenses: [...state.expenses, expense],
    })),
    on(ExpenseActions.createExpenseFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(ExpenseActions.updateExpense, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseActions.updateExpenseSuccess, (state, { expense }) => ({
        ...state,
        isLoading: false,
        expenses: state.expenses.map((r) =>
            r.id === expense.id ? expense : r
        ),
    })),
    on(ExpenseActions.updateExpenseFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(ExpenseActions.deleteExpense, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseActions.deleteExpenseSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        expenses: state.expenses.filter((r) => r.id !== id),
    })),
    on(ExpenseActions.deleteExpenseFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
